import styled from 'styled-components';

export const Container = styled.footer`
  background-color: #1B94AB; 
  padding: 10px 0; 
  text-align: center; 
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;

export const Text = styled.p`
  font-family: "Courgette";
  font-weight: bold;
  font-size: 16px; 
  color: #fff; 
  margin: 0; 
`;
